module.exports = __webpack_public_path__ + "media/src/images/logos/io-logo-48-white-d234b600e8a98ea3ab037e0e9fb39c3a.png";